// extracted by mini-css-extract-plugin
export default {"title":"_5B4kx","message":"_3PXP4","rule":"ZjSbh","checkboxDescription":"_3GpNk","button":"_2o8BF","submitButton":"_3n4uE _2o8BF","error":"_3FubF","footer":"_34LiL"};